//
//
//
//
//
import { heatmapData } from "./heatmapData";
export default {
  mounted: function mounted() {
    var _this = this;

    // 延迟加载，防止出现AMap not defined
    setTimeout(function () {
      _this.initMap();

      _this.createHeatMap();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    this.map && this.map.destroy();
  },
  data: function data() {
    return {
      map: null,
      heatmap: null
    };
  },
  components: {},
  methods: {
    initMap: function initMap() {
      this.map = new AMap.Map('container', {
        resizeEnable: true,
        center: [116.480983, 39.989628],
        zoom: 11,
        mapStyle: 'amap://styles/grey' // 极夜蓝

      });
    },
    //判断浏览区是否支持canvas
    isSupportCanvas: function isSupportCanvas() {
      var elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    },
    createHeatMap: function createHeatMap() {
      if (!this.isSupportCanvas()) {
        return this.$msg.error('热力图仅对支持canvas的浏览器适用,您所使用的浏览器不能使用热力图功能,请换个浏览器试试。');
      }

      var __this = this;

      this.map.plugin(['AMap.Heatmap'], function () {
        //初始化heatmap对象
        __this.heatmap = new AMap.Heatmap(__this.map, {
          // visible: false,
          radius: 50,
          //给定半径
          opacity: [0, 1],
          gradient: {
            0.06: '#287eeb',
            0.12: '#5da4f6',
            0.18: '#59f7f8',
            0.24: '#8afc69',
            0.30: '#f9fe5c',
            0.36: '#fce063',
            0.42: '#f9b240',
            0.48: '#fb8756',
            0.54: '#fd5a5b',
            0.60: '#e44274',
            0.66: '#bc3ab4',
            0.72: '#8c1686',
            0.78: '#6a0d2a',
            0.84: '#3c1527',
            1: '#131313'
          }
        }); //设置数据集：该数据为北京部分“公园”数据

        __this.heatmap.setDataSet({
          data: heatmapData,
          max: 500
        });
      });
    }
  }
};